var map = {
	"./challenge.png": 7337,
	"./codewars.png": 9225,
	"./email.png": 2003,
	"./git.jpg": 8770,
	"./left.png": 9106,
	"./name.png": 6555,
	"./photo.png": 5925,
	"./photo1.png": 5291,
	"./right.png": 1574,
	"./works/HTMLCSS.png": 7846,
	"./works/HTMLCSS2.png": 8342,
	"./works/HTMLCSS3.png": 4996,
	"./works/HTMLCSS4.png": 4082,
	"./works/HTMLCSS5.png": 2293,
	"./works/HTMLCSS6.png": 4529,
	"./works/JS.png": 7332,
	"./works/JS1.1.png": 7149,
	"./works/JS1.2.png": 1372,
	"./works/JS2-1.png": 28,
	"./works/JS2-2.png": 742,
	"./works/JS2-3.png": 1482,
	"./works/JS2.png": 8966,
	"./works/JS3.png": 9797,
	"./works/MitraSoft.png": 9733,
	"./works/MitraSoft1.png": 5266,
	"./works/MitraSoft2.png": 3958,
	"./works/MitraSoft3.png": 9211,
	"./works/Pharmacy.png": 5335,
	"./works/Pharmacy2.png": 7479,
	"./works/Pharmacy3.png": 2148,
	"./works/Pharmacy4.png": 3269,
	"./works/Pharmacy5.png": 3690,
	"./works/React1-2.png": 5089,
	"./works/React1-3.png": 6491,
	"./works/React1-4.png": 4487,
	"./works/React1-5.png": 4170,
	"./works/React1.png": 8200,
	"./works/React2.png": 7272,
	"./works/React3-0.png": 1902,
	"./works/React3-1.png": 1498,
	"./works/React3.png": 5445,
	"./works/React4-1.png": 7551,
	"./works/React4-2.png": 4977,
	"./works/React4-3.png": 3639,
	"./works/React4-4.png": 9734,
	"./works/React4-5.png": 9776,
	"./works/React4-6.png": 9202,
	"./works/React4-7.png": 279,
	"./works/React4.png": 6668,
	"./works/React5-1.png": 6424,
	"./works/React5-2.png": 4098,
	"./works/React5.png": 3416,
	"./works/adaptiv.png": 9811,
	"./works/adaptiv1.png": 9672,
	"./works/adaptiv2.png": 4648,
	"./works/adaptiv3.png": 84,
	"./works/adaptiv4.png": 9459,
	"./works/adaptiv5.png": 645,
	"./works/adaptiv6.png": 3158,
	"./works/dashboard1.png": 2374,
	"./works/dashboard2.png": 8458,
	"./works/dashboard3.png": 5902,
	"./works/dashboard4.png": 187,
	"./works/dashboard5.png": 3780,
	"./works/game1-2.png": 4786,
	"./works/game1-3.png": 6724,
	"./works/game1.png": 3074,
	"./works/game2.png": 1872,
	"./works/port1.png": 8945,
	"./works/port2.png": 1186,
	"./works/port3.png": 3441,
	"./works/port4.png": 4124,
	"./works/port5.png": 3493,
	"./works/port6.png": 8613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4339;